import React, { forwardRef, Fragment, RefObject } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { useChatContext } from '@modules/support';

import Modal from '@components/NewModal';

import ModalContent from './ModalContent';
import useIsDesktop from './useIsDesktop';
import { RowData } from '../useRowData';

import style from './Details.scss';

const cn = bemCssModules(style, 'Details');
const ti = getTestId('Details');

export type TDetails = {
  className?: string;
  data: RowData;
  isOpen?: boolean;
  onClose?: () => void;
  modalRef?: RefObject<HTMLDivElement | null>;
  isFailed?: boolean;
};

const Details = forwardRef<HTMLDivElement, TDetails>((props, ref) => {
  const { className, data, isOpen, onClose, modalRef, isFailed } = props;

  const { t } = useTranslation();
  const { open } = useChatContext();
  const isDesktop = useIsDesktop();

  const content = (
    <>
      {Object.entries(data.details).map(([name, details]) => (
        <div key={name} className={cn('content')}>
          {details.map(
            (columns, i) =>
              columns[1] && (
                /* eslint-disable-next-line react/no-array-index-key */
                <Fragment key={`${name}${i}`}>
                  <small>{columns[0]}</small>
                  <small>{columns[1]}</small>
                </Fragment>
              )
          )}
        </div>
      ))}
      <div className={cn('buttons')}>
        <button className="link" type="button" onClick={open}>
          {t('transaction.report')}
        </button>
      </div>
    </>
  );

  return isDesktop ? (
    <div className={cn({ hidden: !isOpen }, [className])} ref={ref} data-testid={ti()}>
      {content}
    </div>
  ) : (
    <Modal className={cn('modal')} ref={modalRef} isOpen={isOpen} onClose={onClose} overlay>
      <ModalContent data={data} isFailed={isFailed}>
        {content}
      </ModalContent>
    </Modal>
  );
});

export default Details;
